export default __webpack_public_path__ + "static/media/linkedin.d8f343f7.svg";